(() => {
    function renderLanguageList(availableLanguages, defaultLanguage) {
        var myDiv = document.querySelector("#country-selector .select-container--language");
        let _details = myDiv.querySelector('.language__details');
        if (!_details) {
        var detailsElement = document.createElement("details");
        detailsElement.setAttribute("for","language");
        detailsElement.className = "language__details";
        detailsElement.role = "button";
        var detailsSummary = document.createElement("summary");
        detailsElement.appendChild(detailsSummary);
        var detailsUl = document.createElement("ul");
        detailsElement.appendChild(detailsUl);

            myDiv.appendChild(detailsElement);
        } else {
            var detailsSummary = myDiv.querySelector('.language__details summary');
            var detailsUl = myDiv.querySelector('.language__details ul');
            detailsUl.innerHTML = '';
        }

        let _select = myDiv.querySelector('#Language');
        if (!_select) {
            var selectList = document.createElement("select");
            selectList.name = "language";
            selectList.id = "Language";
            selectList.style.display = 'none';
            myDiv.appendChild(selectList);
        } else {
            var selectList = _select
            _select.innerHTML = '';
        }
        var currentLang = (navigator.language || navigator.userLanguage) || 'en';
        currentLang = currentLang.split('-')[0];
        let hasUsersLanguage = availableLanguages.find((lang)=>lang == currentLang);

        //Create and append the options
        availableLanguages.forEach((lang,index)=>{
            var option = document.createElement("option");
            var liEl = document.createElement("li");
            liEl.dataset.key = index;
            liEl.setAttribute('role','button');
            liEl.setAttribute('tabIndex','0');
            let languageNames = new Intl.DisplayNames([lang], { type: "language" });
            let langName = languageNames.of(lang.toUpperCase());
            langName = langName[0].toLocaleUpperCase() + langName.slice(1);
            option.value = lang;
            option.text = langName;
            liEl.innerHTML = `<span class="text-content">${langName}</span>`;
            if ((hasUsersLanguage && lang === currentLang) || (defaultLanguage && lang === defaultLanguage) || availableLanguages.length == 1) {
                option.selected = "selected";
                liEl.appendChild(document.querySelector('#country-selector-tick').content.cloneNode(true).firstElementChild);
                detailsSummary.innerHTML =`<div tabindex="0"><span class="text-content">${langName}</span>` + document.querySelector('#country-selector-downchevron').content.cloneNode(true).firstElementChild.outerHTML + '</div>';
            }
            selectList.appendChild(option);
            detailsUl.appendChild(liEl);
        });
        return selectList;
    }


try {
    let popupFormStates = [];
    let browsingContext = '';
    function initSelector() {
        let popups = document.querySelectorAll('#country-selector');
        let details = document.querySelectorAll('#country-selector details');
        let allCountriesJson = getAllCountriesJson();

        popups.forEach((popup)=>{
            try {
                popup.querySelector('.popup-container').addEventListener('click', popupClickHandler);
                popup.querySelector('.popup-content-container').addEventListener('click', popupContentClickHandler);
                popup.querySelector('.close-button').addEventListener('click', popupClickHandler);

                let popupForm = popup.querySelector('form')

                if (popupForm) {
                    popupForm.addEventListener('submit', formSubmit)
                    popupForm.querySelector('button, .btn').addEventListener('click', ()=>{
                        let event = new Event('submit');
                        popupForm.dispatchEvent(event);
                    });
                    let obj = {item: popupForm, state: getPopupFormState(popupForm)};
                    let lang = 'en';
                    if (obj.state.language != lang) {
                        obj.state.language = lang;
                    }
                    popupFormStates.push(obj);
                } else {
                    let buttons = popup.querySelector('.popup__button-container').querySelectorAll('button, .btn');
                    buttons.forEach((button)=>{
                        let func;
                        switch (button.dataset?.buttonAction?.toLowerCase()) {
                            case 'edit':
                                func = ()=>{openCountrySelector()}
                                break;
                            default:
                                func = ()=>{
                                    setStorage();
                                    closePopup({currentTarget: popup})
                                };
                        }
                        if (func) {
                            button.addEventListener('click',  func);
                        }
                    });
                }
            } catch (e) {
                console.error(e);
            }
        });
        renderButtons();


        details.forEach((detailEl)=>{
            let forValue = detailEl.attributes.for.value;
            let hiddenSelect = detailEl.parentElement.querySelector(`[name="${forValue}"]`);
            detailEl.addEventListener('click', detailClickHandler);
            detailEl.addEventListener('keyup', (e)=>{
                let keycodes = [13,32];
                if (e.target.closest('li') && keycodes.includes(e.keyCode)) {
                    detailClickHandler(e);
                }
            });


            function detailClickHandler(e) {
                e?.preventDefault();
                e?.stopPropagation();
                let target = e.target;
                let isOpen = detailEl.getAttribute('open') === '';
                if (target.closest('summary') || document.activeElement == detailEl) {
                    if (isOpen) {
                        closeDetail(detailEl);
                    } else {
                        openDetail(detailEl);
                    }
                    return;
                }
                let liEl = target.closest('li');
                if (liEl) {
                    let node = target.closest('ul').querySelector('svg');
                    liEl.appendChild(node);
                    closeDetail(detailEl);
                    let key = liEl?.dataset?.key;
                    if (key) {
                        hiddenSelect.selectedIndex = Number(key);
                        let summary = detailEl.querySelector('summary');
                        if (forValue?.toLowerCase() == 'location') {
                            let store = allCountriesJson[Number(key)];
                            // let templateStr = document.querySelector('.template-popup__title--current').cloneNode(true).textContent;

                            // if (templateStr) {
                            //     liEl.closest('.popup-content-container').querySelector('.popup__title--current').innerText = templateStr.replace(/\{.*?\}/,store.name);
                            // }
                            if (store.code) {
                                let img = summary.querySelector('img')
                                let imgSrc = img.src;
                                let searchStr = imgSrc.slice(imgSrc.indexOf('/', imgSrc.indexOf('circle')) + 1);
                                img.src = imgSrc.replace(searchStr,`${store.code.toLowerCase()}.svg`);
                            }
                            let languages = store.languages.split(',').map((item)=>item.trim());
                            renderLanguageList(languages, store.defaultLanguage);
                        }
                        summary.querySelector('span').innerText = liEl.querySelector('.text-content').textContent;
                    }
                }
            };
        });
    }

    function renderButtons() {
        let allCountriesJson = getAllCountriesJson();
        let currentStore = allCountriesJson.find((country)=>{ return Shopify.shop.includes(country.permanent_url)})
        let countryCode = currentStore.code;
        let buttons = document.querySelectorAll('.js-country-selector-button-trigger');
        let langCode = 'en';
        let languageNames = new Intl.DisplayNames(["en"], { type: "language" });
        let language = languageNames.of(langCode.toUpperCase());
        buttons.forEach((button)=>{
            button.ariaLabel = `Currently selected language: ${language}. Currently selected store: ${currentStore.name}. Select button to change store`;
            switch (button.dataset?.buttonAction?.toLowerCase()) {
                default:
                // case 'edit':
                    func = ()=>{openCountrySelector()}
                    break;
                //     func = ()=>{
                //         openIncorrectPagePopup();
                //     };
            }
            if (func) {
                button.addEventListener('click',  func);
            }

            button.innerHTML = `<img src="https://cdn.weglot.com/flags/circle/${countryCode?.toLowerCase()}.svg" class="country-selector-button__flag" width="16" height="16" role="none" alt="${language} flag"/><span class="country-selector-button__text-content">${language}</span>`;
        });
    }

    function openDetail(detailEl) {
        closeAllDetails();
        detailEl.setAttribute('open', '');
        detailEl.querySelectorAll('li').forEach((liEl, index)=>{
            // if (index == 0) {
            //     liEl.focus();
            // }
            liEl.setAttribute('tabIndex','0');
            liEl.setAttribute("data-acsb-now-navigable","true");
            liEl.setAttribute("aria-hidden","false");
            liEl.setAttribute("data-acsb-hidden","false");
        });
        requestAnimationFrame(() => {
            Array.from(detailEl.querySelectorAll('ul li')).slice(-1).pop().scrollIntoView();
        });
    }
    function closeDetail(detailEl) {
        detailEl.removeAttribute('open');
        detailEl.querySelectorAll('li').forEach((liEl)=>{
            liEl.setAttribute('tabIndex','-1');
            liEl.setAttribute("data-acsb-now-navigable","false");
            liEl.setAttribute("aria-hidden","true");
            liEl.setAttribute("data-acsb-hidden","true");
            if (document.activeElement == liEl) {
                detailEl.focus();
            }
        });
    }
    function closeAllDetails() {
        document.querySelector('#country-selector').querySelectorAll('details[open]').forEach((detailEl)=>{
            closeDetail(detailEl);
        });
    };
    function openCountrySelector() {
        let popups = document.querySelectorAll('#country-selector');


        popups.forEach((popup)=>{
            if (popup.id != "country-selector") {
                closePopup({currentTarget: popup});
            } else {
                openPopup({currentTarget: popup});
            }
        })
    }

    
    function popupClickHandler(e) {
        e.preventDefault?.();
        e.stopPropagation?.();
        closePopup(e);
        closeAllDetails();
        setStorage();
    }
    
    function popupContentClickHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        closeAllDetails();
    }
    
    function closePopup(e) {
        let section = e.currentTarget?.closest('section');
        document.querySelector('html').style.overflow = '';
        document.querySelector('body').classList.remove('country_selector--open');
        document.querySelector('body').style.overflow = '';
        if (section) {
            section.style.display = 'none';
            section.hidden = "true";
            section.tabIndex = "-1";
        }
    }
    function openPopup(e) {
        let section = e.currentTarget?.closest('section');
        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').classList.add('country_selector--open')
        document.querySelector('body').style.overflow = 'hidden';
        if (section) {
            section.style.display = '';
            section.hidden = "";
            section.tabIndex = "0";
            section.focus();
        }
    }
    
    function formSubmit(e) {
        e.preventDefault();
        let currentTarget = e.currentTarget;
        let previousFormStateIndex = 0;
        let previousFormState = popupFormStates.find((form,index)=>{ previousFormStateIndex = index; return form.item == currentTarget }).state;
        let currentFormState = getPopupFormState(currentTarget);
        if (JSON.stringify(previousFormState) == JSON.stringify(currentFormState)) {
            setStorage();
            closePopup(e);
            return;
        }
        popupFormStates[previousFormStateIndex].state = JSON.parse(JSON.stringify(currentFormState));
        let changedStates = Object.entries(previousFormState).reduce((current, previous)=>{
            if (current[previous[0]] != previous[1]) {
                current[previous[0]] = current[previous[0]];
            }
            return current;
        }, currentFormState);

        let urlStr = '';

        let selectOption = getAllCountriesJson().find((item)=>{ return item.code.toLowerCase() == changedStates?.location?.toLowerCase() });

        if (changedStates.location) {
            if (selectOption.url && selectOption.permanent_url !== Shopify.shop) {
                urlStr = selectOption.url;
            }
        }
        if (changedStates.language) {
            if (urlStr) {
                if (urlStr.includes('myshopify.')) {
                    if (selectOption.languages.split(',').length > 1) {
                        urlStr += `?changeLanguage=${changedStates.language}`;
                    }
                } else {
                    let changedLanguage = `${changedStates.language}.`;
                    if (selectOption.base_language == changedStates.language) {
                        changedLanguage = ''
                    }
                    if (selectOption.languages.split(',').length > 1) {
                        urlStr = `${changedLanguage}${urlStr}?no_redirect=true`;
                    }
                }
            } else {
                setStorage();
                closePopup(e);
                //Weglot.switchTo(changedStates.language);
                renderButtons();
                return;
            }
        }
        if (urlStr) {
            location.href = `//${urlStr}`;
        } else {
            throw "COUNTRY SELECTOR: MISSING URL";
        }
    }
    function setStorage() {
        let storage = Pandectes.consent.functionality ? localStorage : sessionStorage;
        let storageAlt = !Pandectes.consent.functionality ? localStorage : sessionStorage;
        storageAlt.removeItem('seenIncorrectStore')
        return storage.setItem('seenIncorrectStore', 'true');
    }
    function checkStorage() {
        let storage = Pandectes.consent.functionality ? localStorage : sessionStorage;
        return storage.getItem('seenIncorrectStore')?.toLowerCase() == 'true';
    }
    function getPopupFormState(popupForm) {
        let formData = new FormData(popupForm);
        let entries = Array.from(formData.entries());
        return entries.reduce((prev, cur)=>{
            prev[cur[0]] = cur[1];
            return prev
        }, {});
    }
    function getAllCountriesJson() {
        return JSON.parse(document.querySelector('#all-countries').textContent);
    }





    window.addEventListener("DOMContentLoaded", ()=>{
        renderLanguageList(['en']);
        initSelector();
        let allCountriesJson = getAllCountriesJson();
        window.incorrectStore = false;
        let currentStore = allCountriesJson.find((country)=>{
            return country.permanent_url == Shopify.shop;
        });
        document.querySelectorAll('#country-selector .popup__title--current').forEach((title)=>{
            title.innerText = document.querySelector('.template-popup__title--current').cloneNode(true).textContent.replace(/\{.*?\}/,currentStore.name)
        });

        window.addEventListener("PandectesEvent_OnInitialize", async () => {
            browsingContext = await fetch('/browsing_context_suggestions.json?cache=false').then(res=>res.json()).catch(e=>console.error(e));
            let userCountryCode = browsingContext.detected_values.country.handle?.toLowerCase();

            window.usersRecommendedStore = allCountriesJson.find((country)=>{
                return country.countries.toLowerCase().includes(userCountryCode.toLowerCase());
            }) || allCountriesJson.find((country)=>{
                return country.countries == '';
            });

            let userIsOnCorrectStore = Shopify.shop.includes(usersRecommendedStore.permanent_url);
            let userHasSeenPopup = checkStorage();
            
            if (!userHasSeenPopup && !userIsOnCorrectStore) {
                window.incorrectStore = true;
                let locationIndex = Array.from(document.querySelector('#Location').options).findIndex((item)=>{
                    if (item?.value == usersRecommendedStore.code?.toUpperCase()) {
                        return true
                    }
                })
                document.querySelectorAll('.location__details li')[locationIndex].click()
                openPopup({currentTarget: document.querySelector('#country-selector')});
            }
            window.addEventListener(Pandectes.EVENT.ON_CONSENT, () => {
                setStorage()
            });
        });
    });
} catch (e) {
    throw e;
}
window.removeCountrySelectorStorage = () => {
    localStorage.removeItem('seenIncorrectStore');
    sessionStorage.removeItem('seenIncorrectStore');
}
})();
